export function isInsideIFrame() {
    return window.self !== window.top;
}
//# sourceMappingURL=iframe.js.map